import React from "react";
import "../style/services.css";
import { useNavigate } from "react-router-dom";

import medicine from "../assets/internal-medicine.png";
import orthopedic from "../assets/orthopedics.png";
import general from "../assets/general-surgery-gopi.png";
import pediatric from "../assets/pedia.png";
import urology from "../assets/urology.png";
import gastrology from "../assets/gestrointestinal-medicine.png";
// import gisurgery from "../assets/dermatology.png";
import ent from "../assets/ent.png";
// import neurology from "../assets/gestrointestinal-medicine.png";
import intensivecare from "../assets/critical-care.png";
import trauma from "../assets/trauma-care.png";
import joint from "../assets/joint-replacement.png";

const servicesList = [
    { img: medicine, title: "Medicine", link: "/services/medicine" },
    { img: orthopedic, title: "Orthopedic", link: "/services/orthopedic" },
    { img: general, title: "General Surgery", link: "/services/general-surgery" },
    { img: pediatric, title: "Pediatric", link: "/services/pediatric" },
    { img: urology, title: "Urology", link: "/services/urology" },
    { img: gastrology, title: "Gastrology", link: "/services/gastrology" },
    // { img: gisurgery, title: "GI Surgery" },
    { img: ent, title: "ENT", link: "/services/ent" },
    // { img: neurology, title: "Neurology" },
    { img: intensivecare, title: "Critical Care", link: "/services/critical-care" },
    { img: trauma, title: "Trauma Care", link: "/services/trauma-care" },
    { img: joint, title: "Joint Replacement", link: "/services/joint-replacement" },

];
const Services = () => {
    const navigate = useNavigate();

    return (
        <div className="specialites-section">
            <div className="container">
                <div className="specialities-je">

                    <div className="specialities-head-jp">
                        <span className="specialities-heading">— Our Services —</span>
                    </div>

                    <div className="specialities-grid">
                        {servicesList.map((item, index) => (
                            <div
                                className="specialities-card"
                                key={index}
                                onClick={() => navigate(item.link)}      
                            >
                                <img src={item.img} alt={item.title} className="specialities-img" />
                                <p className="specialities-title">{item.title}</p>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Services;